/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The type of security policy:
 *   * BASIC128RSA15
 *   * BASIC256
 *   * BASIC256SHA256
 *   * AES128SHA256RSAOAEP
 *   * AES256SHA256RSAPSS
 */
export enum SecurityPolicy {
  BASIC128RSA15 = 'BASIC128RSA15',
  BASIC256 = 'BASIC256',
  BASIC256SHA256 = 'BASIC256SHA256',
  AES128SHA256RSAOAEP = 'AES128SHA256RSAOAEP',
  AES256SHA256RSAPSS = 'AES256SHA256RSAPSS'
}
